import React, { useEffect, useState } from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import { SCREEN_WIDTH } from "../../common";
import Container from "../../components/Container";
import CustomButton from "../../components/CustomButton";
import CustomIcon from "../../components/CustomIcon";
import Header from "../../components/Header";
import { connect } from "react-redux";
import { addOrder, setCheckoutOrderInfo } from "../../actions/order";
import Loading from "../../components/Loading";
import { removeCartItem } from "../../actions/cart";
// import UPIPayment from "../../common/UPIPayment";
import Addresses from "../../components/Addresses";
import { setAddresses } from "../../actions/user";
import Content from "../../components/Content";
// import { displayRazorPay } from "../../common/Payment";

function PlaceOrder({
  navigation,
  checkoutOrder = {},
  setCheckoutOrderInfo,
  removeCartItem,
  addOrder,
  setAddresses,
}) {
  const [currentStep, setCurrentStep] = useState({ key: "Shipping", index: 0 });

  const Shipping = () => {
    const [addressInfo, setAddressInfo] = useState(null);
    const [isReady, setIsReady] = useState(false);
    const [disable, setDisable] = useState(false);

    const handleContinueToPay = () => {
      const { name, address, phone, pincode, city, state } = addressInfo;
      setCheckoutOrderInfo({
        ...checkoutOrder,
        address: { name, address, phone, pincode, city, state },
      });
      setCurrentStep({ key: "Payment", index: 1 });
    };

    useEffect(() => {
      fetchApi({
        path: "/users/me/addresses",
      }).then((res) => {
        if (res.results) {
          setAddresses(res.results);
        }
        setIsReady(true);
      });
    }, []);

    return (
      <Content scrollEnabled loading={!isReady} style={{ padding: 0 }}>
        <Text style={styles.title}>{currentStep.key}</Text>
        <View style={{ paddingHorizontal: 5 }}>
          <Addresses
            onSelectUpdate={(data) => setAddressInfo(data)}
            onFormShow={() => {
              setDisable(true);
            }}
            onFormHide={() => {
              setDisable(false);
            }}
          />
          {!disable ? (
            <CustomButton
              text="Continue to Pay"
              btnStyle={styles.btn}
              onPress={handleContinueToPay}
              textStyle={styles.btnTxt}
            />
          ) : null}
        </View>
      </Content>
    );
  };

  const Payment = () => {
    // const successCallback = (obj) => {
    //   setCheckoutOrderInfo({
    //     ...checkoutOrder,
    //     payment: obj,
    //     order_type: "UPI",
    //   });
    //   setCurrentStep({ key: "Order Placed", index: 2 });
    // };

    // const failureCallback = (e) => {
    //   console.log(e, "f");
    // };

    const handleUPIPayment = () => {
      // displayRazorPay({
      //   amount: checkoutOrder.amount,
      //   name: "StyleOn",
      //   description: "Total amount",
      // })
      //   .then((res) => console.log(res, "r"))
      //   .catch((res) => console.log(res, "e"));
      // UPIPayment.initializePayment(
      //   {
      //     vpa: "siddayya96-1@okicici", // or can be john@ybl or mobileNo@upi
      //     payeeName: "Siddaiah M",
      //     amount: checkoutOrder.amount,
      //     transactionRef: "aasf-332-aoei-fn",
      //   },
      //   successCallback,
      //   failureCallback
      // );
    };

    return (
      <View style={{ padding: 10, flex: 1 }}>
        <Text style={styles.title}>{currentStep.key}</Text>
        <View style={styles.card}>
          <View style={styles.cardItem}>
            <Text style={styles.text}>Credit Card</Text>
            <Text style={styles.text}>Bank Name</Text>
          </View>
          <View
            style={{
              width: 40,
              height: 40,
              backgroundColor: "orange",
            }}
          />
          <View>
            <View style={styles.cardItem}>
              <Text style={styles.text}>XXXX</Text>
              <Text style={styles.text}>XXXX</Text>
              <Text style={styles.text}>XXXX</Text>
              <Text style={styles.text}>XXXX</Text>
            </View>
            <Text style={{ color: "white" }}>xxxx</Text>
            <Text style={[styles.text, { alignSelf: "flex-end" }]}>mm/yy</Text>
            <Text style={styles.text}>Name Surname</Text>
          </View>
          <View
            style={{
              position: "absolute",
              width: SCREEN_WIDTH - 55,
              height: (SCREEN_WIDTH - 25) / 1.7,
              left: 0,
              top: 0,
              backgroundColor: "#ffffff90",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{ fontWeight: "bold", fontSize: STYLES.fontSizes.large }}
            >
              This feature is under process
            </Text>
          </View>
        </View>
        <View style={{ flex: 1, justifyContent: "space-between" }}>
          <View>
            <CustomButton
              text="Cash On Delivery"
              btnStyle={styles.btn}
              onPress={() => {
                setCheckoutOrderInfo({
                  ...checkoutOrder,
                  order_type: "COD",
                });
                setCurrentStep({ key: "Order Placed", index: 2 });
              }}
              textStyle={styles.btnTxt}
            />
            <CustomButton
              text="Pay through UPI"
              btnStyle={styles.btn}
              disabled
              onPress={handleUPIPayment}
              textStyle={styles.btnTxt}
            />
          </View>
          <CustomButton
            text={`Pay Now ${"$" + checkoutOrder.amount}`}
            btnStyle={[styles.btn, { backgroundColor: "grey" }]}
            disabled={true}
            onPress={() => setCurrentStep({ key: "Order Placed", index: 2 })}
            textStyle={styles.btnTxt}
          />
        </View>
      </View>
    );
  };

  const OrderPlaced = () => {
    const [orderConfirm, setOrderConfirm] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const [quetion, setQuestion] = useState({});
    const [loading, setLoading] = useState(false);
    const [solution, setSolution] = useState("");

    const placeOrder = () => {
      fetchApi({
        path: "/orders",
        method: "POST",
        body: checkoutOrder,
      }).then((res) => {
        if (!res.error) {
          addOrder(res);
          checkoutOrder.items.map(({ _id, item_id }) => {
            fetchApi({
              path: `/cart/${_id}`,
              method: "DELETE",
            }).then((res) => {
              if (!res.error) {
                removeCartItem({ item_id, _id });
              }
            });
          });
          setOrderConfirm(true);
          setIsReady(true);
          setLoading(false);
        }
      });
    };

    useEffect(() => {
      if (checkoutOrder.order_type !== "COD") {
        placeOrder();
      } else {
        generateEquation();
        setIsReady(true);
      }
    }, []);

    const generateEquation = () => {
      let op = [
        { op: "+", calc: (a, b) => a + b },
        { op: "-", calc: (a, b) => a - b },
        { op: "*", calc: (a, b) => a * b },
      ];
      let opr = op[parseInt(Math.random() * 10) % 3];
      let a = parseInt(Math.random() * 10);
      let b = parseInt(Math.random() * 10);
      setQuestion({
        qtn: `${a} ${opr.op} ${b} = ?`,
        sol: opr.calc(a, b),
      });
    };

    return (
      <>
        {isReady ? (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            {orderConfirm ? (
              <>
                <CustomIcon
                  type="AntDesign"
                  name="checkcircleo"
                  style={{
                    color: STYLES.colors.purpel,
                    fontSize: STYLES.fontSizes.xxlarge * 4,
                  }}
                />
                <Text style={styles.title}>Your Order is Confirmed</Text>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: STYLES.fontSizes.xlarge,
                  }}
                >
                  Thank For Your Order
                </Text>
                <CustomButton
                  text="Done"
                  onPress={() => {
                    navigation.navigate("tabs", { screen: "favourite" });
                  }}
                  btnStyle={[
                    styles.btn,
                    { width: "40%", paddingVertical: 10, marginTop: 20 },
                  ]}
                  textStyle={styles.btnTxt}
                />
              </>
            ) : (
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Text>Solve below equation to confirm the order.</Text>
                <Text
                  style={{
                    fontSize: STYLES.fontSizes.xxlarge,
                    marginVertical: 5,
                  }}
                >
                  {quetion.qtn}
                </Text>
                <TextInput
                  style={{
                    borderWidth: 1,
                    fontSize: STYLES.fontSizes.xlarge,
                    width: "25%",
                    marginVertical: 10,
                  }}
                  keyboardType="numeric"
                  onChangeText={(value) => {
                    setSolution(value);
                  }}
                />
                <CustomButton
                  text="Place Order"
                  btnStyle={{ backgroundColor: "#000000", width: "70%" }}
                  textStyle={{ color: "#ffffff" }}
                  onPress={() => {
                    if (solution == quetion.sol) {
                      setLoading(true);
                      placeOrder();
                    }
                  }}
                />
              </View>
            )}
            {loading ? <Loading spinner /> : null}
          </View>
        ) : (
          <Loading />
        )}
      </>
    );
  };

  const steps = {
    Shipping: <Shipping />,

    Payment: <Payment />,

    "Order Placed": <OrderPlaced />,
  };

  return (
    <Container>
      <Header backButton title="Cart" navigation={navigation} rightIcons={[]} />
      <View style={styles.container}>
        <View
          style={[
            styles.cardItem,
            {
              marginBottom: 20,
            },
          ]}
        >
          {Object.keys(steps).map((key, index) => (
            <Text
              key={index + "ds"}
              style={{
                fontSize: STYLES.fontSizes.large,
                fontWeight: "bold",
                color:
                  key === currentStep.key || index < currentStep.index
                    ? "#000000"
                    : "#00000050",
              }}
            >
              {key}
            </Text>
          ))}
        </View>
        {steps[currentStep.key]}
      </View>
    </Container>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  title: {
    fontSize: STYLES.fontSizes.xxlarge,
    fontWeight: "bold",
  },
  card: {
    backgroundColor: "#000000",
    marginVertical: 10,
    borderRadius: 10,
    height: (SCREEN_WIDTH - 25) / 1.7,
    paddingVertical: 15,
    paddingHorizontal: 20,
    justifyContent: "space-between",
  },
  addContainer: {
    borderWidth: 1,
    flexDirection: "row",
    padding: 5,
    marginVertical: 5,
  },
  text: {
    color: "#ffffff",
    fontSize: STYLES.fontSizes.medium * 1.1,
  },
  btn: {
    backgroundColor: "#000000",
    width: "90%",
    alignSelf: "center",
  },
  cardItem: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  btnTxt: { color: "#ffffff", fontSize: STYLES.fontSizes.medium },
});

const mapStateToProps = (state) => ({
  checkoutOrder: state.order.checkoutOrder,
});

const mapDispatchToProps = (dispatch) => ({
  setCheckoutOrderInfo: (data) => dispatch(setCheckoutOrderInfo(data)),
  removeCartItem: (data) => dispatch(removeCartItem(data)),
  addOrder: (data) => dispatch(addOrder(data)),
  setAddresses: (data) => dispatch(setAddresses(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PlaceOrder);
